import * as z from 'zod'
import { Driver } from '~/shared/api'
import { Option, OptionEnum } from '~/shared/config/constants'
import { CountryEnum } from '~/shared/config/countryEnum'
import { InfoSourceEnum } from '~/shared/config/enums'
import { FeatureFlagsEnum } from '~/shared/lib/featureFlag/constants'
import { buildI18nMessage } from '~/shared/lib/i18nMessageHelper'

export const formSchema = Driver.schema
  .pick({
    lastName: true,
    firstName: true,
    middleName: true,
    birthDate: true,
    phone: true,
    inn: true,
    snils: true,
    ogrnip: true,
    email: true,
    passportIssueDate: true,
    citizenship: true,
    registrationAddress: true,
    passportNumber: true,
    drivingExperienceStartDate: true,
    drivingLicenseIssuingCountry: true,
    drivingLicenseNumber: true,
    drivingLicenseIssueDate: true,
    drivingLicenseExpirationDate: true,
    divisionCode: true,
    passportIssued: true,
    placeOfResidence: true,
    data: true,
    comment: true,
    regionId: true,
  })
  .extend({
    email: z
      .string()
      .min(1, buildI18nMessage('validate.required field'))
      .email(buildI18nMessage('validate.invalid email address')),
  })

export const getFormSchema = (featureFlags: FeatureFlagsEnum[]) => {
  if (featureFlags.includes(FeatureFlagsEnum.show_info_source)) {
    return formSchema.extend({
      infoSource: Driver.schema.shape.infoSource,
    })
  }
  return formSchema
}

export type BaseSchemaType = z.infer<typeof formSchema>

export type FullSchemaType = BaseSchemaType & {
  infoSource?: InfoSourceEnum[] | OptionEnum<InfoSourceEnum>[]
}

export type FormValues = Omit<
  FullSchemaType,
  'regionId' | 'citizenship' | 'drivingLicenseIssuingCountry' | 'email'
> & {
  regionId: UniqueId | Option | null
  citizenship: CountryEnum | OptionEnum<CountryEnum> | null
  drivingLicenseIssuingCountry: CountryEnum | OptionEnum<CountryEnum> | null
  email: string | null | undefined
}
